import { useLayoutManager } from "./composables/use-layout-manager";
import {
  defineNuxtRouteMiddleware,
  SalesChannel,
  setPageLayout,
} from "#imports";

export default defineNuxtRouteMiddleware(() => {
  const { activeSalesChannel } = useLayoutManager();

  if (activeSalesChannel.value === SalesChannel.MOBILE_APP) {
    setPageLayout("mobile-app");
  }
});
